import cn from 'classnames';

import { IConDefaultType } from '..';
import { TosspayIconDark, TosspayIconLight } from '../../foundations/assets/image';

export enum PaymentMethodIconVariant {
  KAKAOPAY = 'kakaopay',
  NAVERPAY = 'naverpay',
  PAYCO = 'payco',
  TOSS = 'toss',
}

export interface IPaymentMethodIconProps extends IConDefaultType {
  variant?: PaymentMethodIconVariant;
}

const PaymentMethodDefaultStyleInfo = {
  kakaopay: { width: 53, heightRatio: 22 / 53 },
  naverpay: { width: 58, heightRatio: 22 / 58 },
  payco: { width: 68, heightRatio: 15 / 68 },
  toss: { width: 79, heightRatio: 17 / 79 },
};

export default function PaymentMethodIcon({
  color,
  className,
  size,
  rotate,
  flip,
  variant = PaymentMethodIconVariant.KAKAOPAY,
}: IPaymentMethodIconProps) {
  const isDarkMode = localStorage.getItem('theme') === 'dark';

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size ?? PaymentMethodDefaultStyleInfo[variant].width,
        minWidth: size ?? PaymentMethodDefaultStyleInfo[variant].width,
        height:
          (size ?? PaymentMethodDefaultStyleInfo[variant].width) * PaymentMethodDefaultStyleInfo[variant].heightRatio,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === PaymentMethodIconVariant.KAKAOPAY && (
        <svg height={'100%'} viewBox="0 0 53 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_9238_718312)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M41.9613 22H11.1777C5.10311 22 0.177734 17.0746 0.177734 11C0.177734 4.92537 5.10311 0 11.1777 0H41.9887C48.0633 0 52.9887 4.92537 52.9887 11C52.9887 17.0746 48.0359 22 41.9613 22Z"
              fill="#FFEB00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.5184 5.28125C9.20747 5.28125 6.52588 7.38821 6.52588 10.0151C6.52588 11.6842 7.64777 13.1618 9.31692 14.0101L8.7423 16.1444C8.71493 16.1992 8.7423 16.2812 8.79702 16.336C8.82439 16.3633 8.87911 16.3907 8.90648 16.3907C8.93384 16.3907 8.98856 16.3633 9.01593 16.3633L11.4513 14.7215C11.807 14.7763 12.1627 14.8036 12.5458 14.8036C15.8567 14.8036 18.5383 12.6693 18.5383 10.0698C18.5383 7.38822 15.8567 5.28125 12.5184 5.28125Z"
              fill="black"
            />
            <path
              d="M23.6009 13.9591V17.0238H21.4119V5.72283H22.9442L23.2178 6.43427C23.683 5.9691 24.3945 5.47656 25.5163 5.47656C27.6507 5.47656 28.6631 7.06363 28.6631 9.66313C28.6631 12.3721 27.1034 14.096 24.8596 14.096C24.4218 14.1233 24.0935 14.096 23.6009 13.9591ZM23.6009 7.55616V12.4268C23.7104 12.4542 24.0114 12.4815 24.3124 12.4815C25.8721 12.4815 26.4741 11.387 26.4741 9.66313C26.4741 8.15815 26.0636 7.25517 24.8323 7.25517C24.3945 7.25517 23.9566 7.36462 23.6009 7.55616Z"
              fill="black"
            />
            <path
              d="M33.3967 8.92038H34.628V8.64675C34.628 7.74376 34.1081 7.33331 33.2325 7.33331C32.5484 7.33331 31.7002 7.52486 30.9887 7.88058L30.3867 6.43033C31.1529 5.88306 32.3569 5.52734 33.4241 5.52734C35.5037 5.52734 36.6529 6.62187 36.6529 8.72884V13.9005H35.1206L34.9017 13.2164C34.0261 13.8458 33.2052 14.1194 32.4937 14.1194C30.9066 14.1194 30.0037 13.1617 30.0037 11.5472C30.0037 9.82336 31.1803 8.92038 33.3967 8.92038ZM34.6554 11.7935V10.2885H33.643C32.5211 10.2885 31.9464 10.699 31.9464 11.4925C31.9464 12.0945 32.2474 12.3955 32.9042 12.3955C33.5061 12.4229 34.2723 12.1219 34.6554 11.7935Z"
              fill="black"
            />
            <path
              d="M43.2746 13.0523C42.5084 15.0772 41.6055 16.5548 40.2647 17.3757L38.9239 16.1443C39.69 15.4603 40.2647 14.8035 40.7298 13.9279L37.8293 6.01996L39.991 5.44533L41.8517 11.8483L43.6851 5.41797L45.8194 6.01996L43.2746 13.0523Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_9238_718312">
              <rect width="52.7836" height="22" fill="white" transform="translate(0.178467)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === PaymentMethodIconVariant.NAVERPAY && (
        <svg height={'100%'} viewBox="0 0 59 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_9238_718325)">
            <mask
              id="mask0_9238_718325"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="2"
              width="59"
              height="18"
            >
              <path d="M58.6465 2H0.492676V20H58.6465V2Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9238_718325)">
              <path
                d="M57.4635 5.57706L51.6765 18.5821H48.9966L50.8485 14.4601L46.4001 5.57706H49.161L52.1175 11.6521L54.7905 5.57706H57.4635ZM45.0885 15.5671H42.5235V14.8493C41.6976 15.4755 40.6865 15.8074 39.6501 15.7921C36.822 15.7921 34.6034 13.4971 34.6034 10.5721C34.6034 7.64706 36.822 5.35207 39.6501 5.35207C40.6865 5.33679 41.6976 5.66865 42.5235 6.29481V5.57706H45.0885V15.5671ZM40.0056 7.51206C38.3901 7.51206 37.1706 8.82831 37.1706 10.5721C37.1706 12.3158 38.3901 13.6321 40.0056 13.6321C41.6211 13.6321 42.8406 12.3158 42.8406 10.5721C42.8406 8.82831 41.6211 7.51206 40.0056 7.51206ZM22.7234 5.57706H25.2884V6.29481C26.1151 5.66896 27.1271 5.33715 28.1639 5.35207C30.9921 5.35207 33.2084 7.64481 33.2084 10.5721C33.2084 13.4993 30.9921 15.7921 28.1639 15.7921C27.1652 15.8071 26.1882 15.4993 25.3784 14.9146V18.5821H22.7234V5.57706ZM24.9734 10.5721C24.9734 12.3158 26.1929 13.6321 27.8084 13.6321C29.4239 13.6321 30.6434 12.3158 30.6434 10.5721C30.6434 8.82831 29.4239 7.51206 27.8084 7.51206C26.1929 7.51206 24.9734 8.82831 24.9734 10.5721Z"
                fill="#00DE5A"
              />
              <path
                d="M18.4927 11C18.4927 12.78 17.9649 14.5201 16.9759 16.0001C15.987 17.4802 14.5814 18.6337 12.9368 19.3149C11.2923 19.9961 9.48271 20.1744 7.73688 19.8271C5.99105 19.4798 4.38739 18.6227 3.12872 17.364C1.87005 16.1053 1.01288 14.5017 0.665611 12.7558C0.318344 11.01 0.496578 9.20038 1.17777 7.55584C1.85896 5.91133 3.01252 4.50571 4.49255 3.51677C5.9726 2.52784 7.71265 2 9.49268 2C11.8796 2 14.1688 2.94821 15.8566 4.63604C17.5445 6.32388 18.4927 8.61306 18.4927 11ZM11.3737 6.365V11.5985L7.69943 6.365H4.85768V15.635H7.61393V10.3993L11.2882 15.635H14.1277V6.365H11.3737Z"
                fill="#00DE5A"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9238_718325">
              <rect width="58.1538" height="18" fill="white" transform="translate(0.493408 2)" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === PaymentMethodIconVariant.PAYCO && (
        <svg height={'100%'} viewBox="0 0 69 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M63.8237 10.8547C63.1068 11.63 62.1239 12.0842 60.888 12.0842C59.6521 12.0842 58.6691 11.63 57.9522 10.8547C57.2905 10.1184 56.911 9.17117 56.911 8.00986C56.911 6.84854 57.271 5.90133 57.9328 5.16497C58.6497 4.38968 59.652 3.93553 60.8847 3.93553C62.1174 3.93553 63.1035 4.38968 63.8204 5.16497C64.4822 5.90133 64.8617 6.84854 64.8617 8.00986C64.8617 9.17117 64.4822 10.1151 63.8204 10.8547H63.8237ZM66.2047 2.59256C64.839 1.28852 62.9835 0.516473 60.8912 0.516473C58.7989 0.516473 56.9402 1.28852 55.5777 2.59256C54.1731 3.93878 53.3849 5.85591 53.3849 8.00661C53.3849 10.1573 54.1731 12.0744 55.5777 13.4239C56.9402 14.728 58.7989 15.5 60.8912 15.5C62.9835 15.5 64.8423 14.728 66.2047 13.4239C67.6093 12.0777 68.3976 10.1606 68.3976 8.00661C68.3976 5.85267 67.6093 3.93878 66.2047 2.59256Z"
            fill="#FF2233"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.3971 10.3647L50.329 10.449C49.8522 11.0394 49.3202 11.4579 48.6973 11.7206C48.2075 11.9477 47.6009 12.0807 46.9521 12.0807C45.6902 12.0807 44.5743 11.659 43.8445 10.8707C43.1665 10.1538 42.787 9.13199 42.787 7.9869C42.787 6.65366 43.319 5.56047 44.2045 4.82411C44.9247 4.23696 45.7551 3.89635 46.9554 3.89635C47.523 3.89635 48.0745 4.00989 48.5676 4.20128C49.1515 4.42511 49.6478 4.78842 50.1441 5.28474L50.2155 5.3561L52.7911 3.19567L52.723 3.11133C51.9931 2.20304 51.1238 1.54778 50.3063 1.17149C49.3558 0.736804 48.188 0.5 46.8743 0.5C44.8436 0.5 43.0465 1.17149 41.7003 2.33929C40.1562 3.70496 39.2511 5.68374 39.2511 7.99339C39.2511 9.92674 39.9031 11.6492 41.0288 12.9533C42.4107 14.5168 44.4673 15.4835 46.8743 15.4835C48.4086 15.4835 49.6348 15.1883 50.6469 14.6142C51.5617 14.0984 52.2916 13.3653 52.9403 12.4213L52.9987 12.3337L50.3906 10.3712V10.3614L50.3971 10.3647Z"
            fill="#FF2233"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.2451 0.873808L32.2153 6.84905L29.2082 0.873808H25.1469L30.4506 10.5374V15.108H33.9832V10.5374L39.2837 0.873808H35.2451Z"
            fill="#FF2233"
          />
          <path
            d="M19.8658 4.15014L21.744 9.16195H18.02L19.8658 4.15014ZM17.5107 0.873808L12.2134 15.1048H15.8206L16.8295 12.3604H22.9377L23.9693 15.1048H27.557L22.2014 0.873808H17.5107Z"
            fill="#FF2233"
          />
          <path
            d="M8.60935 7.86764C8.34984 7.98766 7.91516 8.13039 7.30855 8.13039H4.07439V4.03984H7.13014C7.65241 4.03984 8.15845 4.1177 8.44391 4.24097C8.8494 4.41614 9.13811 4.65943 9.32301 4.9903C9.4852 5.27901 9.56306 5.62286 9.56306 6.04781C9.56306 6.96583 9.2484 7.56595 8.60286 7.87088V7.86439L8.60935 7.86764ZM11.8759 2.72607C11.3569 2.08702 10.7017 1.59071 9.88745 1.25334C9.26462 0.990587 8.31416 0.873808 7.58753 0.873808H0.74292V15.1048H4.27552V11.2543H7.58753C8.45689 11.2543 9.50467 11.0564 10.2605 10.6995C11.2791 10.2227 12.0381 9.38253 12.4923 8.3899C12.8069 7.67624 12.9886 6.88149 12.9886 6.04781C12.9886 4.79892 12.5928 3.64409 11.8759 2.72931V2.72607Z"
            fill="#FF2233"
          />
        </svg>
      )}
      {variant === PaymentMethodIconVariant.TOSS && (
        <img
          src={isDarkMode ? TosspayIconDark : TosspayIconLight}
          alt="Toss Pay"
          style={{ width: '100%', height: '100%' }}
        />
      )}
    </i>
  );
}
